import React from 'react';
import { observer, inject } from 'mobx-react';

import Constraint from 'js/components/Constraint';
import Backdrop from 'js/components/core/Backdrop';
import StepMessage from 'js/components/core/SteppedPage/StepMessage';
import Title from 'js/components/core/SteppedPage/Title';
import ProgressRow from 'js/components/core/SteppedPage/ProgressRow';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';

import ShippingSelector from './ShippingSelector';
import EstimateNote from './EstimateNote';

export default inject('page')(
  observer(({ page }) => (
    <>
      <Backdrop>
        <Constraint>
          <Title>Shipping method</Title>
        </Constraint>
      </Backdrop>

      <Constraint>
        <ShippingSelector
          state={page.shippingSelector}
          alias={page.alias}
          destination={page.address}
          onChange={page.setShippingService}
        />
        {page.shipping_service && <EstimateNote>* post-shipping estimations</EstimateNote>}

        <ProgressRow>
          <ContinueButton onClick={page.nextStep} />
        </ProgressRow>

        {page.shipping_service && <StepMessage>You won't be charged yet</StepMessage>}
      </Constraint>
    </>
  )),
);
